import axios from 'axios';

import { AuthInterceptor, AuthService, AuthTokenService } from '@sine/auth-client';

import { AuthHelpers } from '../helpers/auth.helpers';
import { sessionStorage, storage } from '../services/storage/storage.service';
import deviceService from './device.service';

const authService = new AuthService({
  authApiUrl: window.env.REACT_APP_SINE_ID_API_URI,
  coreAuthApiUrl: window.env.REACT_APP_SINE_CORE_API_URI,
  rootClientUrl: `${window.location.origin}${window.env.PUBLIC_URL}`,
  rootClientAuthApiUrl: window.env.REACT_APP_SINE_ID_API_URI,
  storage,
  sessionStorage,
  axiosInstance: axios,
});

export const authTokenService = new AuthTokenService(storage, sessionStorage);
export const authHelpers = new AuthHelpers(authService);

const authInterceptor = new AuthInterceptor(axios, authService);
authInterceptor.startIntercepting();

// Create a promise that resolves when initialization is complete
let initResolve: (() => void) | null = null;
export const authInitialized = new Promise<void>((resolve) => {
  initResolve = resolve;
});

// Initialize events and then resolve the promise
void authHelpers.initialiseEvents().then(() => {
  initResolve?.();
});

let registeredDeviceToken: string | undefined;
function handleDeviceTokenChanged(newDeviceToken: string | undefined) {
  if (registeredDeviceToken && registeredDeviceToken !== newDeviceToken) {
    registeredDeviceToken = undefined;
    authService.trashUser();
  } else if (newDeviceToken) {
    registeredDeviceToken = newDeviceToken;
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    authService.initialize();
  }
}

handleDeviceTokenChanged(deviceService.getDeviceToken());
deviceService.addDeviceTokenListener(handleDeviceTokenChanged);

export default authService;
